var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('tbody',[[_c('div',{staticClass:"Rectangle-12-Copy-2"},[_vm._l((_vm.rows),function(row){return _vm._t("ODrows",null,{row:row})})],2)]],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03f9afbf","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/table-disenar-escala/app-table-disenar-escala-Odata.vue
// module id = 1244
// module chunks = 115